import { Box, Flex, Image } from "@chakra-ui/react";
import React from "react";
import loaderImg from "../../assets/gif/loader.gif";

const PageLoader = () => {
  return (
    <Flex
      w={"100%"}
      h={"100vh"}
      alignItems={"center"}
      justifyContent={"center"}
      bg={"#DCDCDC"}
    >
      <Image
        src={loaderImg}
        alt="Loader"
        w={{ base: "150px", lg: "250px" }}
        h={{ base: "150px", lg: "250px" }}
      />
    </Flex>
  );
};

export default PageLoader;
